import { render, staticRenderFns } from "./NgBlockHtml.vue?vue&type=template&id=2e54afb8"
import script from "./NgBlockHtml.vue?vue&type=script&lang=js"
export * from "./NgBlockHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports